import { memo, useCallback } from "react";
import BinIcon from "../../../../assets/icons/BinIcon";
import { ExtraSmallButton } from "../../../custom";

export type RemoveCellProps = {
    clientOrderId: string,
    onRemove: (clientOrderId: string) => void
}

const removeButtonSx = {
    width: 30,
    height: 30,
    minWidth: 30,
    p: 0,
    "& .MuiSvgIcon-root": { fontSize: 18 },
} as const

const RemoveCell: React.FC<RemoveCellProps> = ({clientOrderId, onRemove}) => {

    const removeOrder = useCallback(() => {
        onRemove(clientOrderId);
    }, [clientOrderId, onRemove])
    return (
        <ExtraSmallButton
            variant="text"
            color="inherit"
            size="small"
            onClick={removeOrder}
            sx={removeButtonSx}
            aria-label="Remove order"
        >
            <BinIcon />
        </ExtraSmallButton>
    )
}

export default memo(RemoveCell);
